import apiRequest from "../../utils/apiRequest";

/**
 * Service du domaine Reports (2026-05-26).
 *
 * <p>Contrat back :
 * <ul>
 *   <li>{@code GET /financial-report?from&to&statuses&practitionerId
 *       &insurerId&groupBy&page&size} → {@code FinancialReportResponse}
 *       (synthèse + breakdowns + timeseries + page invoices).</li>
 * </ul>
 *
 * <p>{@code from} et {@code to} sont obligatoires au format YYYY-MM-DD.
 * {@code statuses} accepte plusieurs valeurs (PENDING | PAID | FAILED) ;
 * répété sous forme {@code ?statuses=PENDING&statuses=PAID}. Les autres
 * filtres sont optionnels et omis quand vides.
 */

export interface FinancialReportParams {
  from: string;
  to: string;
  statuses?: string[];
  practitionerId?: number | null;
  insurerId?: number | null;
  groupBy?: "day" | "week" | "month";
  page?: number;
  size?: number;
}

export const getFinancialReport = async (params: FinancialReportParams) => {
  const qs = new URLSearchParams();
  qs.set("from", params.from);
  qs.set("to", params.to);
  (params.statuses || []).forEach((s) => qs.append("statuses", s));
  if (params.practitionerId != null) {
    qs.set("practitionerId", String(params.practitionerId));
  }
  if (params.insurerId != null) {
    qs.set("insurerId", String(params.insurerId));
  }
  if (params.groupBy) qs.set("groupBy", params.groupBy);
  qs.set("page", String(params.page ?? 0));
  qs.set("size", String(params.size ?? 20));
  return apiRequest.get(`/financial-report?${qs.toString()}`);
};
